import _objectWithoutProperties from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["$metadata"];
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var loggerMiddleware = function loggerMiddleware() {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var _logger$info, response, clientName, commandName, logger, _context$dynamoDbDocu, dynamoDbDocumentClientOptions, overrideInputFilterSensitiveLog, overrideOutputFilterSensitiveLog, inputFilterSensitiveLog, outputFilterSensitiveLog, _response$output, $metadata, outputWithoutMetadata, _logger$error, _clientName, _commandName, _logger, _context$dynamoDbDocu2, _dynamoDbDocumentClientOptions, _overrideInputFilterSensitiveLog, _inputFilterSensitiveLog;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return next(args);
              case 3:
                response = _context.sent;
                clientName = context.clientName, commandName = context.commandName, logger = context.logger, _context$dynamoDbDocu = context.dynamoDbDocumentClientOptions, dynamoDbDocumentClientOptions = _context$dynamoDbDocu === void 0 ? {} : _context$dynamoDbDocu;
                overrideInputFilterSensitiveLog = dynamoDbDocumentClientOptions.overrideInputFilterSensitiveLog, overrideOutputFilterSensitiveLog = dynamoDbDocumentClientOptions.overrideOutputFilterSensitiveLog;
                inputFilterSensitiveLog = overrideInputFilterSensitiveLog !== null && overrideInputFilterSensitiveLog !== void 0 ? overrideInputFilterSensitiveLog : context.inputFilterSensitiveLog;
                outputFilterSensitiveLog = overrideOutputFilterSensitiveLog !== null && overrideOutputFilterSensitiveLog !== void 0 ? overrideOutputFilterSensitiveLog : context.outputFilterSensitiveLog;
                _response$output = response.output, $metadata = _response$output.$metadata, outputWithoutMetadata = _objectWithoutProperties(_response$output, _excluded);
                logger === null || logger === void 0 ? void 0 : (_logger$info = logger.info) === null || _logger$info === void 0 ? void 0 : _logger$info.call(logger, {
                  clientName: clientName,
                  commandName: commandName,
                  input: inputFilterSensitiveLog(args.input),
                  output: outputFilterSensitiveLog(outputWithoutMetadata),
                  metadata: $metadata
                });
                return _context.abrupt("return", response);
              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                _clientName = context.clientName, _commandName = context.commandName, _logger = context.logger, _context$dynamoDbDocu2 = context.dynamoDbDocumentClientOptions, _dynamoDbDocumentClientOptions = _context$dynamoDbDocu2 === void 0 ? {} : _context$dynamoDbDocu2;
                _overrideInputFilterSensitiveLog = _dynamoDbDocumentClientOptions.overrideInputFilterSensitiveLog;
                _inputFilterSensitiveLog = _overrideInputFilterSensitiveLog !== null && _overrideInputFilterSensitiveLog !== void 0 ? _overrideInputFilterSensitiveLog : context.inputFilterSensitiveLog;
                _logger === null || _logger === void 0 ? void 0 : (_logger$error = _logger.error) === null || _logger$error === void 0 ? void 0 : _logger$error.call(_logger, {
                  clientName: _clientName,
                  commandName: _commandName,
                  input: _inputFilterSensitiveLog(args.input),
                  error: _context.t0,
                  metadata: _context.t0.$metadata
                });
                throw _context.t0;
              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 13]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};
export var loggerMiddlewareOptions = {
  name: "loggerMiddleware",
  tags: ["LOGGER"],
  step: "initialize",
  override: true
};
export var getLoggerPlugin = function getLoggerPlugin(options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
    }
  };
};